package com.sweetlime.dungeonamigo.presentation.ui.theme

import androidx.compose.ui.graphics.Color

fun classColorFor(characterClass: String): Color = when (characterClass.lowercase().trim()) {
    "barbarian" -> BrandColors.Ember            // #E84545
    "fighter"   -> BrandColors.IvoryDim         // #B0A898
    "paladin"   -> BrandColors.Parchment        // #D4A843
    "ranger"    -> BrandColors.Venom            // #6FA84A
    "bard"      -> Color(0xFF9B6FD9)            // purple
    "cleric"    -> Color(0xFFF4837C)            // light ember
    "druid"     -> Color(0xFF5FA86A)            // soft green
    "monk"      -> Color(0xFF5BC0BE)            // teal
    "rogue"     -> BrandColors.SlateLight       // #7A7A9A
    "warlock"   -> Color(0xFFB254C4)            // magenta
    "sorcerer"  -> BrandColors.EmberAmber       // #E0833E
    "wizard"    -> BrandColors.SpellBlue        // #4A90D9
    else        -> BrandColors.Slate
}

fun raceColorFor(race: String): Color = when (race.lowercase().trim()) {
    "human"      -> BrandColors.Parchment       // #D4A843
    "elf"        -> Color(0xFF9B6FD9)           // purple
    "dwarf"      -> BrandColors.EmberAmber      // #E0833E
    "halfling"   -> BrandColors.Venom           // #6FA84A
    "gnome"      -> Color(0xFF5BC0BE)           // teal
    "half-elf"   -> Color(0xFF5FA86A)           // soft green
    "half-orc"   -> BrandColors.Ember           // #E84545
    "tiefling"   -> Color(0xFFB254C4)           // magenta
    "dragonborn" -> BrandColors.SpellBlue       // #4A90D9
    else         -> BrandColors.Slate
}
